<template>
    <div class="row">
        <div class="col-md-3 col-sm-12" style="margin-bottom: 20px">
            <label for="season" style="font-weight: bold">Seleccionar temporada</label>
            <select name="season" id="season" class="form-control" v-model="season" @change="reloadSeason">
                <option v-for="season in seasons" :value="season.id">{{season.name}}</option>
            </select>
        </div>
        <div class="col-md-9"></div>
    </div>
</template>

<script>

import axios from "axios";
import swal from "sweetalert2";

    export default {
        created() {
            this.loadSeasons();
        },
        data() {
            return {
                seasons: [],
                season: this.$store.getters.season
            };
        },
        methods: {
          loadSeasons() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'seasons', {
              params: {
                jwt: vm.$store.getters.jwt
              }
            }).then(response => {
              if (response.data.response) {
                vm.seasons = response.data.result;
              } else {
                swal({
                  title: 'Atención',
                  text: response.data.message,
                  confirmButtonClass: 'btn btn-info btn-fill',
                  type: 'error'
                });

              }
            }).catch(e => {
              swal({
                title: 'Atención',
                text: e,
                confirmButtonClass: 'btn btn-info btn-fill',
                type: 'error'
              });

            });
          },
            reloadSeason() {
                this.$store.dispatch('setSeason', this.season);

                var date = new Date;
                date.setDate(date.getDate() + 21);
                this.$cookie.set('season', this.season, {expires: date});

                this.$emit('reload');

            }
        }
    }
</script>

<style scoped>

</style>